/* eslint-disable no-undef */
(function () {
  var script = document.createElement('script');
  var cacheTimestamp = new Date().getTime();

  script.src = document.currentScript.src.replace('embed.js', 'js/main.js?v=' + cacheTimestamp);
  script.async = true;
  script.defer = document.currentScript.defer;
  script.type = document.currentScript.type;

  document.head.appendChild(script);
})();
